import React from 'react';

import { useSankeyRenderContext } from 'contexts/sankeyRenderContext';
import { flowInHumanFormat } from 'diagram/flows';
import Alert from 'ui/Alert';
import List from 'ui/List';

const InvalidComparisonAmountsBanner: React.FC = () => {
  const { flows } = useSankeyRenderContext();
  const invalidFlows = flows.filter((f) => f.amountComparison <= 0);

  if (invalidFlows.length > 0) {
    return (
      <Alert
        status="warning"
        title="Comparison amounts must be greater than 0. You can leave the fields blank instead."
      >
        <List.Root>
          {invalidFlows.map((flow) => {
            const humanizedFlow = flowInHumanFormat(flow);
            return (
              <List.Item key={humanizedFlow} fontSize="xs">
                {humanizedFlow}
              </List.Item>
            );
          })}
        </List.Root>
      </Alert>
    );
  }

  return null;
};

export default InvalidComparisonAmountsBanner;
